import apicaller from '@/utils/apicaller';
import api from '@/main.api';

export default {
  // Datasource
  getDataSources: () =>
    apicaller.get(api.MANAGEMENT.dataSources.getDataSources),
  // EntityWizard uçları datasource nesnesini bekler (DataSourceDTO / EntityWizardDTO.DataSourceDetails);
  // yalnız adı göndermek backend'de NullReferenceException'a düşüyordu.
  getSchemas: (dataSource) =>
    apicaller.post(api.ENTITYWIZARD.getSchemasFromDatasource, dataSource),
  getTables: (dataSource, schema) =>
    apicaller.post(api.ENTITYWIZARD.getTablesFromDatasource, {
      dataSourceName: dataSource.name,
      dataSourceSchemaName: schema,
      dataSourceTableName: '',
      dataSourceDetails: dataSource,
    }),
  getColumns: (dataSource, schema, table) =>
    apicaller.post(api.ENTITYWIZARD.getColumnsFromDatasource, {
      dataSourceName: dataSource.name,
      dataSourceSchemaName: schema,
      dataSourceTableName: table,
      dataSourceDetails: dataSource,
    }),
  executeDatasetSql: (sql) =>
    apicaller.post(api.ARTIFICIALINT.executeDatasetSql, JSON.stringify(sql)),

  // Classification
  trainClassification: (payload) =>
    apicaller.post(api.ARTIFICIALINT.trainModel, payload),
  saveClassificationModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.saveTrainModel, payload),
  listClassificationModels: () =>
    apicaller.get(api.ARTIFICIALINT.classificationModels),
  deleteClassificationModel: (id) =>
    apicaller.delete(`${api.ARTIFICIALINT.classificationModels}/${id}`),
  applyClassificationModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyClassificationModel, payload),
  predictClassification: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyClassificationModel, payload),
  explainClassificationModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.explainClassificationModel, payload),

  // Multiclass
  trainMulticlass: (payload) =>
    apicaller.post(api.ARTIFICIALINT.trainMulticlass, payload),
  listMulticlassModels: () =>
    apicaller.get(api.ARTIFICIALINT.multiclassModels),
  saveMulticlassModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.multiclassModels, payload),
  deleteMulticlassModel: (id) =>
    apicaller.delete(`${api.ARTIFICIALINT.multiclassModels}/${id}`),
  applyMulticlassModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyMulticlassModel, payload),

  // Regression
  trainRegression: (payload) =>
    apicaller.post(api.ARTIFICIALINT.trainRegression, payload),
  listRegressionModels: () =>
    apicaller.get(api.ARTIFICIALINT.regressionModels),
  saveRegressionModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.regressionModels, payload),
  deleteRegressionModel: (id) =>
    apicaller.delete(`${api.ARTIFICIALINT.regressionModels}/${id}`),
  applyRegressionModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyRegressionModel, payload),

  // Clustering
  trainClustering: (payload) =>
    apicaller.post(api.ARTIFICIALINT.trainClustering, payload),
  listClusteringModels: () =>
    apicaller.get(api.ARTIFICIALINT.clusteringModels),
  saveClusteringModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.clusteringModels, payload),
  deleteClusteringModel: (id) =>
    apicaller.delete(`${api.ARTIFICIALINT.clusteringModels}/${id}`),
  applyClusteringModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyClusteringModel, payload),
  getScatterData: (payload) =>
    apicaller.post(api.ARTIFICIALINT.getScatterData, payload),
  compareClusteringModels: (payload) =>
    apicaller.post(api.ARTIFICIALINT.compareModels, payload),
  clusteringElbow: (payload) =>
    apicaller.post(api.ARTIFICIALINT.clusteringElbow, payload),

  // Anomaly
  trainAnomaly: (payload) =>
    apicaller.post(api.ARTIFICIALINT.trainAnomaly, payload),
  listAnomalyModels: () =>
    apicaller.get(api.ARTIFICIALINT.anomalyModels),
  saveAnomalyModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.anomalyModels, payload),
  deleteAnomalyModel: (id) =>
    apicaller.delete(`${api.ARTIFICIALINT.anomalyModels}/${id}`),
  applyAnomalyModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.applyAnomalyModel, payload),

  getTrainJob: (id) =>
    apicaller.get(`${api.ARTIFICIALINT.trainJobs}/${id}`),
  listTrainJobs: (limit, offset) =>
    apicaller.get(`${api.ARTIFICIALINT.trainJobs}?limit=${limit}&offset=${offset}`),
  cancelTrainJob: (id) =>
    apicaller.post(`${api.ARTIFICIALINT.trainJobs}/${id}/cancel`),

  // Yanlış Pozitif Azaltma sihirbazı (ML bağlantısı)
  fpReductionSchemas: () =>
    apicaller.get(api.ARTIFICIALINT.fpReductionSchemas),
  fpReductionTables: (schema) =>
    apicaller.get(`${api.ARTIFICIALINT.fpReductionTables}?schema=${encodeURIComponent(schema)}`),
  fpReductionProfile: (source) =>
    apicaller.post(api.ARTIFICIALINT.fpReductionProfile, source),
  fpReductionValueDistribution: (source, columnName) =>
    apicaller.post(api.ARTIFICIALINT.fpReductionValueDistribution, { source, columnName }),
  startFeatureExperiment: (payload) =>
    apicaller.post(api.ARTIFICIALINT.fpReductionFeatureExperiments, payload),

  // ML Decision Rules (çoklu-model AND/OR karar politikaları)
  listRules: () =>
    apicaller.get(api.MLRULE.base),
  getRule: (id) =>
    apicaller.get(`${api.MLRULE.base}/${id}`),
  saveRule: (payload) =>
    apicaller.post(api.MLRULE.base, payload),
  updateRule: (payload) =>
    apicaller.put(api.MLRULE.base, payload),
  deleteRule: (id) =>
    apicaller.delete(`${api.MLRULE.base}/${id}`),
  evaluateRule: (payload) =>
    apicaller.post(api.MLRULE.evaluate, payload),
  getRulesByScenario: (scenarioId) =>
    apicaller.get(`${api.MLRULE.byScenario}/${scenarioId}`),
  getRulesBySavedQuery: (savedQueryId) =>
    apicaller.get(`${api.MLRULE.bySavedQuery}/${savedQueryId}`),
  linkSavedQuery: (payload) =>
    apicaller.post(api.MLRULE.linkSavedQuery, payload),
  getAlertVerdict: (alertId) =>
    apicaller.get(`${api.MLRULE.byAlert}/${alertId}`),

  // Teknik Analiz (ML engineer dashboard)
  getAnalysisSummary: () =>
    apicaller.get(api.ARTIFICIALINT.analysisSummary),
  getAnalysisScenarioBreakdown: () =>
    apicaller.get(api.ARTIFICIALINT.analysisScenarioBreakdown),
  getAnalysisTimeline: (days) =>
    apicaller.get(`${api.ARTIFICIALINT.analysisTimeline}?days=${days}`),
  getAnalysisEvaluations: (page, pageSize) =>
    apicaller.get(`${api.ARTIFICIALINT.analysisEvaluations}?page=${page}&pageSize=${pageSize}`),
  getAnalysisEffectiveness: (payload) =>
    apicaller.post(api.ARTIFICIALINT.analysisEffectiveness, payload),
  deepEvaluateModel: (payload) =>
    apicaller.post(api.ARTIFICIALINT.analysisEvaluateModel, payload),
};
